import {
  AUTH_SUCCEEDED,
  AUTH_FAILED,
  CLIENT_UPDATED,
  LOGOUT_SUCCEEDED,
  READ_CURRENT_USER_SUCCEEDED,
} from "../actions";

export const isAuthenticated = (state = false, action) => {
  switch (action.type) {
    case AUTH_SUCCEEDED:
      return true;
    case AUTH_FAILED:
      return false;
    case LOGOUT_SUCCEEDED:
      return false;
    default:
      return state;
  }
};

export const token = (state = {}, action) => {
  switch (action.type) {
    case AUTH_SUCCEEDED:
      return action.payload.token;
    case LOGOUT_SUCCEEDED:
      return {};
    default:
      return state;
  }
};

export const client = (state = {}, action) => {
  switch (action.type) {
    case CLIENT_UPDATED:
      return action.payload.client;
    case AUTH_SUCCEEDED:
      return action.payload.client;
    case LOGOUT_SUCCEEDED:
      return {};
    default:
      return state;
  }
};

export const user = (state = {}, action) => {
  switch (action.type) {
    case READ_CURRENT_USER_SUCCEEDED:
      return action.payload;
    default:
      return state;
  }
};
